import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { ReferralChannel } from 'api/mylers/types';
import { getReferralChannels } from 'api/mylers';
import EnquiryForm from './EnquiryForm';

type EnquiryFormContainerProps = {
  open: boolean;
  onSubmitSuccess: () => void;
  handleFormClose?: () => void;
};

const EnquiryFormContainer: React.FC<EnquiryFormContainerProps> = props => {
  const { data: referralChannels, isLoading } = useQuery<ReferralChannel[]>(
    ['referralChannels'],
    () => getReferralChannels()
  );

  if (isLoading || !referralChannels) {
    return null;
  }

  const transformedChannelOptions = referralChannels.map(channel => ({
    value: `${channel.id.toString()}-${channel.name}`,
    name: channel.name,
  }));

  const initialOptions = {
    value: '',
    name: 'Select channel',
  };

  const channelOptionsWithDefault = [initialOptions, ...transformedChannelOptions];
  return <EnquiryForm channels={channelOptionsWithDefault} {...props} />;
};

export default EnquiryFormContainer;
